import React from 'react';
import './ThreadHistoryPanel.css'; 

const ThreadHistoryPanel = ({ isOpen, onClose, threads, activeThreadId, onSelectThread, isLoading, onRefresh, onStartNewConversation }) => {
  if (!isOpen) {
    return null;
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Data sconosciuta';
    try {
      return new Date(timestamp * 1000).toLocaleDateString('it-IT', {
        year: '2-digit', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
      });
    } catch (e) {
      return 'Data invalida';
    }
  };

  return (
    <div className={`thread-history-panel ${isOpen ? 'open' : ''}`}>
      <div className="panel-header">
        {/* NUOVO: Raggruppa titolo e bottone '+' */}
        <div className="panel-title-group">
            <h3>CHAT HISTORY</h3> 
            <div className="panel-header-actions"> {/* Wrapper per i bottoni di azione */}            
            <button onClick={onStartNewConversation} className="close-button" title="Nuova Conversazione">
                <img src="/new_chat.svg" alt="Nuova Conversazione" style={{width: '20px', height: '20px'}}/> {/* Icona per chiusura */}
            </button>
        </div>
        </div>
        <div className="panel-header-actions"> {/* Wrapper per i bottoni di azione */}            
            <button onClick={onClose} className="close-button" title="Chiudi Pannello">
                <img src="/close_icon.svg" alt="Chiudi" style={{width: '20px', height: '20px'}}/> {/* Icona per chiusura */}
            </button>
        </div>
      </div>
      <div className="panel-content">
        {isLoading && threads.length === 0 && (
          <div className="loading-history-placeholder">
            <div className="spinner"></div>
            <p>Caricamento cronologia...</p>
          </div>
        )}
        {!isLoading && threads.length === 0 && (
          <p className="no-history-message">Nessuna conversazione precedente trovata.</p>
        )}
        <ul>
          {threads.map(thread => (
            <li
              key={thread.id}
              className={`history-item ${thread.id === activeThreadId ? 'active' : ''}`}
              onClick={() => onSelectThread(thread.id)}
              title={`Anteprima: ${thread.preview}\nCreato il: ${formatDate(thread.created_at)}`}
            >
              <div className="item-preview">{thread.preview || 'Nessuna anteprima'}</div>
              <div className="item-date">{formatDate(thread.created_at)}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ThreadHistoryPanel;